export const API_URL = 'https://api.tizeti.com:8443/api/v1';
export const GENIATECH_URL = 'https://legacy.tizeti.com/geniatechapi/index.php';
export const PAYSTACK_PUBLIC_KEY = "pk_live_48dd0c126b30e969b1b7eff9f27ded163647f4c6";
export const PAYSTACK_TEST_PUBLIC_KEY = "pk_test_e1929473ff607af44d68b320871309eba86d377f";
export const PAYSTACK_TEST_SECRET_KEY = "sk_test_0cf58b55fa999104ff8f2576bd07648967463b6b";
export const VERIFY_PAYSTACK_URL = "https://api.paystack.co/transaction/verify";

